import { useWindowSize } from "usehooks-ts";
import { WIDE_SCREEN } from "@utils/utils";

export function useWideScreen(): boolean {
  const windowSize = useWindowSize();

  return windowSize.width >= WIDE_SCREEN;
}